<template>
  <div class="infoContainer" :class="{'unauth': !$store.state.session.tenant}">
    <TenantAuth ref="TenantAuth" @submitDialog="$store.dispatch('updateSession')" />
    <CreateOrEditStaff ref="CreateOrEditStaff" />

    <div v-if="$store.state.session.tenant" class="companyInfo">
      <div style="display: flex; align-items: center">
        <div class="one_lines" style="
            font-weight: bold;
            font-size: 15px;
            color: #545454;
          ">
          {{ $store.state.session.tenant.name }}
        </div>
      </div>
      <div style="display: flex; align-items: center">
        <div style="margin-right: 10px">{{ l("信用等级") }} :</div>
        <div style="display: flex;">
          <div v-for="(item, index) in 5" :key="index">
            <el-image v-if="index < $store.state.session.tenant.credit_rating" style="width:18px; height:18px"
              :src="GetResourceUrl('backend/icon-star.svg')"></el-image>
            <el-image v-else style="width:18px; height:18px"
              :src="GetResourceUrl('backend/icon-star-un.svg')"></el-image>
          </div>
        </div>

        <el-tooltip v-if="$store.state.session.tenant.credit_rating <= 2" effect="dark" placement="top">
          <div slot="content" style="width:200px">
            <div v-if="$store.state.session.tenant.credit_rating == 0">
              <span class="color-danger">{{ $store.state.basicInfo.credit_ratingList[0].tip_title }}: </span>{{
                $store.state.basicInfo.credit_ratingList[0].tip_content }}
            </div>
            <div v-else-if="$store.state.session.tenant.credit_rating == 1">
              <span class="color-warning">{{ $store.state.basicInfo.credit_ratingList[1].tip_title }}: </span>{{
                $store.state.basicInfo.credit_ratingList[1].tip_content }}
            </div>
            <div v-else-if="$store.state.session.tenant.credit_rating == 2">
              <span class="color-success">{{ $store.state.basicInfo.credit_ratingList[2].tip_title }}: </span>{{
                $store.state.basicInfo.credit_ratingList[2].tip_content }}
            </div>
          </div>
          <div class="credit_level_info" :class="{
            'danger': $store.state.session.tenant.credit_rating == 0,
            'warning': $store.state.session.tenant.credit_rating == 1,
            'success': $store.state.session.tenant.credit_rating == 2,
          }">
            <i class="el-icon-warning"></i>
            {{
              $utils.listFilter(
                $store.state.basicInfo.credit_ratingList,
                $store.state.session.tenant.credit_rating
              )
            }}
          </div>
        </el-tooltip>

      </div>
      <div style="font-size: 12px">
        <div class="ViewLink" @click="clickTenant">
          {{ l("查看认证信息") }}
        </div>
        <div v-if="$store.getters.checkPermission('staff.add')" class="ViewLink" style="margin-left: 20px"
          @click="inviteStaff">
          {{ l("邀请子账号") }}
        </div>
      </div>
    </div>

    <div class="line_1"></div>
    <div v-if="$store.state.session.user.member_quotation_level || $store.state.session.user.member_purchase_level"
      class="memberInfo">

      <template v-if="$store.state.session.user.member_quotation_level">
        <div class="mode">
          <el-image :src="GetResourceUrl('backend/SJT.svg')"></el-image>
          {{ l("商机通") }}
        </div>
        <div class="points">{{ l("企业号码获取") }}（{{ l("剩余") }}/{{ l("总数") }}）: <span>{{
          $store.state.session.user.member_quotation_points }}/{{
              $store.state.session.user.member_quotation_points_max }}</span> {{ l("次/年") }}</div>
        <div class="time"> {{ l("有效期") }}：{{ $store.state.session.user.member_quotation_start_time.slice(0, 10) }} - {{
          $store.state.session.user.member_quotation_end_time.slice(0, 10) }}</div>
      </template>
      <template v-if="$store.state.session.user.member_purchase_level">
        <div class="mode">
          <el-image :src="GetResourceUrl('backend/SCT.svg')"></el-image>
          {{ l("速采通") }}
        </div>
        <div class="points">{{ l("企业号码获取") }}（{{ l("剩余") }}/{{ l("总数") }}）: <span>{{
          $store.state.session.user.member_purchase_points }}/{{ $store.state.session.user.member_purchase_points_max
            }}</span> {{ l("次/年") }}</div>
        <div class="time"> {{ l("有效期") }}：{{ $store.state.session.user.member_purchase_start_time.slice(0, 10) }} - {{
          $store.state.session.user.member_purchase_end_time.slice(0, 10) }}</div>
      </template>
    </div>
    <div class="line_2"></div>
    <div class="managerInfo">
      <div style="
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 10px 0;
          box-sizing: border-box;
        ">
        <div class="label">
          {{ l("专属业务员") }}
        </div>

        <div>
          {{ l("联系人") }} ：{{
            $store.state.session.user[main_manager_type].display_name
          }}
        </div>
        <div>
          {{ l("手机号") }} ：{{ $store.state.session.user[main_manager_type].mobile }}
        </div>
      </div>
      <el-image :src="$store.state.session.user[main_manager_type].avatar" fit="cover"
        style="width: 108px; height: 108px;">
      </el-image>
    </div>
  </div>
</template>

<script>
import TenantAuth from "./operation/TenantAuth.vue";
import CreateOrEditStaff from "@/views/staff/operation/CreateOrEditStaff.vue";

export default {
  name: "TenantManagerInfo",
  components: {
    TenantAuth,
    CreateOrEditStaff,
  },
  data() {
    return {};
  },
  computed: {
    main_manager_type() {
      const manager_role_id =
        this.$store.state.session.user.pre_business_tag.extra_params
          .manager_role_id;
      let return_type;
      if (manager_role_id == 3004) {
        return_type = "manager_shichang";
      } else if (manager_role_id == 3005) {
        return_type = "manager_caigou";
      } else if (manager_role_id == 3006) {
        return_type = "manager_jijiagong";
      }
      return return_type;
    },
  },
  mounted() { },
  methods: {
    clickTenant() {
      this.$refs.TenantAuth.Type = "View";
      this.$refs.TenantAuth.Show(this.$store.state.session.tenant);
    },
    inviteStaff() {
      this.$refs.CreateOrEditStaff.Type = "Create";
      this.$refs.CreateOrEditStaff.Show();
    },
  },
};
</script>

<style scoped lang="scss">
.infoContainer {
  // height: 168px;
  box-sizing: border-box;
  padding: 30px 30px;
  display: flex;
  justify-content: space-between;
  background: #fff;
  flex-grow: 1;
  &.unauth {
    justify-content: center;
  }

  .companyInfo {
    max-width: 315px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px 0;
    flex-shrink: 0;

    .credit_level_info {
      border-width: 1px;
      border-style: solid;
      line-height: 18px;
      font-size: 12px;
      padding: 0 4px;
      border-radius: 2px;
      margin-left: 6px;
      cursor: pointer;

      &.danger {
        color: $dangerColor;
        border-color: $dangerColor;
        background: $dangerPlainColor;
      }

      &.warning {
        color: $warningColor;
        border-color: $warningColor;
        background: $warningPlainColor;
      }

      &.success {
        color: $successColor;
        border-color: $successColor;
        background: $successPlainColor;
      }
    }
  }

  .line_1,
  .line_2 {
    display: none;
    background: #ccc;
    opacity: 0.35;
    height: 88px;
    width: 1px;
    margin: 10px 30px;
  }

  .companyInfo+.line_1,
  .memberInfo+.line_2 {
    display: block;
  }

  .memberInfo {
    max-width: 315px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-shrink: 0;

    .mode {
      display: flex;
      align-items: center;
      font-weight: bold;

      .el-image {
        width: 18px;
        height: 18px;
        margin-right: 6px;
      }
    }

    .points {
      font-size: 12px;
      color: #999;

      span {
        color: $warningColor;
        font-size: 14px;
      }
    }

    .time {
      font-size: 12px;
      color: #999;

      &+.mode {
        margin-top: 6px;
      }
    }
  }

  .managerInfo {
    max-width: 315px;
    height: 108px;
    box-sizing: border-box;
    //background: $warningPlainColor;
    //border: 1px solid $warningColor;
    box-sizing: border-box;
    //border-radius: 6px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    .label {
      font-size: 15px;
      font-weight: bold;
      border-top-right-radius: 6px;
      border-bottom-left-radius: 10px;
    }
  }
}
</style>
